import React from 'react';

import BsyDashBase from '../BsyDashBase';
import BsyMonthYearPane from '../../BsyMonthYearPane';
import BsyThumbList from '../../BsyThumbList';
import BsyFileThumbList from '../../BsyFileThumbList';
import BsyTagList from '../../BsyTagList';
// import { BsyDashUtils } from '../../../utils/DashUtils';
// import {echarts} from '../../../plugins/echarts.js';
import './index.css';
import { BsyUtils } from '../../../utils/Utils';
import BsyMsgBubble from '../../BsyMsgBubble';
import { BsyConfig } from '../../../global/BsyConfig';
import BsyMaskLayer from '../../BsyMaskLayer';
import BsyFormPane from '../../BsyFormPane';
import BsyAlert from '../../BsyAlert';
import TextWidgetFilter from '../../../utils/WidgetFilter/TextWidgetFilter';
import NumberWidgetFilter from '../../../utils/WidgetFilter/NumberWidgetFilter';
import DatetimeWidgetFilter from '../../../utils/WidgetFilter/DatetimeWidgetFilter';
import ComboCheckWidgetFilter from '../../../utils/WidgetFilter/ComboCheckWidgetFilter';
import TextareaWidgetFilter from '../../../utils/WidgetFilter/TextareaWidgetFilter';
import AddressWidgetFilter from '../../../utils/WidgetFilter/AddressWidgetFilter';
import UserWidgetFilter from '../../../utils/WidgetFilter/UserWidgetFilter';
import DeptWidgetFilter from '../../../utils/WidgetFilter/DeptWidgetFilter';
import DeptGroupWidgetFilter from '../../../utils/WidgetFilter/DeptGroupWidgetFilter';
import UserGroupWidgetFilter from '../../../utils/WidgetFilter/UserGroupWidgetFilter';
import SignatureWidgetFilter from '../../../utils/WidgetFilter/SignatureWidgetFilter';
import FileListWidgetFilter from '../../../utils/WidgetFilter/FileListWidgetFilter';
import { dayjsUtils } from '../../../utils/dayjsUtils';
import { getAfterSuffix } from '../../../utils/getAfterSuffix';

export default class BsyDashRiliChart extends BsyDashBase {
    newData = new Date();
    newYear = this.newData.getFullYear();
    newMonth = this.newData.getMonth();
    newWeek = this.newData.getDay();
    newDay = this.newData.getDate();
    minYear = 1900;
    maxYear = 2999;
    monthArray = [
        React.language("date.january"),
        React.language("date.february"),
        React.language("date.march"),
        React.language("date.april"),
        React.language("date.may"),
        React.language("date.june"),
        React.language("date.july"),
        React.language("date.august"),
        React.language("date.september"),
        React.language("date.october"),
        React.language("date.november"),
        React.language("date.december")
    ]

    weekArray = [
        React.language("date.monday.short"),
        React.language("date.tuesday.short"),
        React.language("date.wednesday.short"),
        React.language("date.thursday.short"),
        React.language("date.friday.short"),
        React.language("date.saturday.short"),
        React.language("date.sunday.short")
    ]

    weekArrayCustom = [
        React.language("date.monday.custom"),
        React.language("date.tuesday.custom"),
        React.language("date.wednesday.custom"),
        React.language("date.thursday.custom"),
        React.language("date.friday.custom"),
        React.language("date.saturday.custom"),
        React.language("date.sunday.custom"),
    ]

    trNum = [0, 1, 2, 3, 4, 5]

    isLeapMonth = (year) => {
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
            return [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        } else {
            return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        }
    }

    dayArray = this.isLeapMonth(this.newYear)

    static defaultProps = {
        mountAutoLoad: true,
        FILTER_METHOD: {
            EQ: "eq",
            NE: "ne",
            ALL: "all",
            IN: "in",
            NIN: "nin",
            LK: "like",
            ULK: "unlike",
            EP: "empty",
            NEP: "not_empty",
            GT: "gt",
            GTE: "gte",
            LT: "lt",
            LTE: "lte",
            RG: "range"
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            newYear: this.newYear,
            newMonth: this.newMonth,
            newDay: this.newDay,
            newWeek: this.newWeek,
            selectDay: this.newDay,
            selectMonth: this.newMonth,
            selectYear: this.newYear,
            dateData: {},
            headerData: {},
            reftype: "",
            vm: props.hasOwnProperty("vm") ? props.vm : 0,
            mode: props.hasOwnProperty("mode") ? props.mode : "visit",
            appId: props.appId,
            entryId: props.entryId,
            widgetId: props.widgetId,
            loading: false,
        }
        this.dashRef = React.createRef()
        this.popupFormPath = [...props.popupFormPath];

        if (this.props.bgColorFilter && this.props.bgColorFilter.length > 0 && this.props.bgColorFilter[0].options) {
            this.bkColor = this.props.bgColorFilter[0].options;
            this.bkColorKey = this.props.bgColorFilter[0].tag;
            this.bkColorType = this.props.bgColorFilter[0].type;
        }
    }

    getFilterData = (t) => {
        let e = this.props
            , i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1)
            , a = [];
        let i = i1.filter;
        this.filterMap = i1.filterMap;
        i && (a = a.concat(i))
        t && (BsyUtils.isObjectEmpty(t) || (a = a.concat(t)));
        e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond))
        return BsyUtils.isObjectEmpty(a) ? {} : {
            cond: a,
            rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND
        }
    }

    _setFilterParam = (t) => {
        BsyUtils.isNull(t) || (this.filterParam = t)
    }

    _getStyles = () => {
        const { widgetId } = this.state;
        this.style = BsyUtils.applyFunc(this, this.props.onGetStyles, [widgetId], !1)
        // console.log('rili styles ', this.style)
    }

    create = (res, menu, cb) => {

        let that = this;
        that.popupFormPath = that.popupFormPath || [];
        let _opt = this.props;
        let d1 = {
            formId: _opt.forms[0],
            appId: _opt.appId,
            entryId: _opt.entryId,
            authGroupId: _opt.origin ? null : _opt.authGroupId,
            extDashData: _opt.extDashData,
            popupFormPath: _opt.extDashData ? null : !_opt.origin ? undefined : that.popupFormPath.concat({
                appId: _opt.appId,
                entryId: _opt.entryId,
                formId: _opt.forms[0],
                widgetId: _opt.widgetId,
                // menuId: "create",
                // menuType: 'menu',
                menuId: menu.menuId,
                menuType: menu.menuType || "datamenu"

            }),
        };
        d1 = BsyUtils.checkRefApp(d1);
        let formConfig = {};
        if (res) {
            let that = this;
            that.isSubmitData = false
            const h = res ? res.data.entry : {};

            window.FX.STATIC.appId = h.appId;
            window.FX.STATIC.entryId = h.entryId;
            window.FX.STATIC.INNERLINK = h._id;

            if (!BsyUtils.isObjectEmpty(h.href)) {
                window.FX.STATIC.FORMHREF = h.href;
            }
            else {
                window.FX.STATIC.FORMHREF = null
            }

            formConfig = {
                ...h,
                appId: h.appId,
                entryId: h.entryId,
            }
            formConfig.content.width = '80%';
            formConfig.content.name = h.name;
            formConfig.content.designDataId = res.data ? res.data.dataId : '';
            //designDataId: g ? g.dataId : '',
        }
        that.isSubmitData = false;
        let layerRef = null;
        BsyMaskLayer({
            customCls: 'fadein-right',
            onMaskClick: (event) => {
                // if (event.target.classList.contains("fadein-right")) {
                //   layerRef.close();
                // }
            },
            onContentCreate: (ref) => {
                layerRef = ref;
                return <BsyFormPane
                    hasHeader={true}
                    width={'80%'}
                    {...d1}
                    formConfig={formConfig}
                    mode={"new"}
                    ignoreAuth={_opt.ignoreAuth}
                    ignoreOptAuth={_opt.ignoreOptAuth}
                    ignoreValidate={_opt.ignoreValidate}
                    onClose={(status, data, autoClose) => {
                        if (status) {
                            if(!cb)
                              that.reload({})
                            that.isSubmitData = true;
                          };
                      
                          cb && cb();
                        layerRef && layerRef.close();
                    }}
                />
            }
        })

    }

    BBY_reportCreatForm = (g, isreload, eventType, cb, opt) => {
        let that = this;
        that.isSubmitData = false;
        eventType = eventType || "popupform";
        let n = this.props
            , e = this,
            f = window.$('<div class="x-window-mask modal light"/>').css({
                "z-index": window.FX.STATIC.zIndex++
            }).appendTo("body");
        window.FX.STATIC.IS_EVENT = g.entry.isEvent === true;
        let hasFooter = true;
        if (g.entry.content.isSubmit !== 'no')
            hasFooter = true;
        else
            hasFooter = false;

        window.FX.STATIC.APPID = g.entry.appId;
        window.FX.STATIC.ENTRYID = g.entry.entryId;

        let isref = false;
        let _options = this.props;
        let dd = BsyUtils.checkRefApp({
            appId: _options.appId,
            formId: _options.forms[0],
            entryId: _options.entryId,
        })
        let formview = new window.FX.Form(window.$.extend(g.entry.content, {
            renderEl: window.$("<div class='x-shadow-content'/>").appendTo(f),
            appId: g.entry.appId,
            entryId: g.entry.entryId,
            enableRowEdit: g.entry.enableRowEdit,
            hasFlow: !g.entry.hasCoop && g.entry.hasFlow,
            designDataId: g ? g.dataId : '',
            hasFlowPrint: g.entry.hasFlowPrint,
            flows: g.entry.flow,
            is_dock_form: g.is_dock_form,
            multiTabs: g.entry.formTabs,
            formTabsStyle: g.entry.formTabsStyle || {},
            isEvent: g.entry.isEvent,
            height: "100%",
            width: 1080,
            submitText: React.language("submit"),
            eventType: eventType,
            hasFooter: hasFooter,
            printText: g.entry.hasFlowPrint ? g.entry.flow.print_text : null,
            // buttonPosition: "middle",
            customCls: "more-btn fui_platform",
            submitUrl: "/data/create",
            title: g.entry.name,
            popupFormPath: e.popupFormPath.concat({
                appId: e.props.appId,
                entryId: e.props.entryId,
                formId: e.props.forms[0],
                widgetId: e.props.widgetId,
                menuId: opt.menuId,
                menuType: opt.menuType || 'datamenu',
            }),
            onSuccess: function (a, flowAction, needPrint) {
                isref = true;
                if (a.error_code) {
                    let title = React.language("form.submit.fail.charger");
                    let msg = React.language("form.submit.fail.charger.desc");
                    if (a.error_code == window.FX.CONST.FLOW_FAIL_CODE.FORWARD_COND) {
                        title = React.language("form.submit.fail.cond");
                        msg = a.error_info //;
                    }
                    window.FX.Msg.alert({
                        title: title,
                        msg: msg,
                        type: "warning",
                        text4Cancel: null,
                        text4Ok: React.language("iSee")
                    });
                    return;
                }
                that.isSubmitData = true
                formview.element.find('.widget-wrapper').empty();
                formview.element.find('.footer').remove();
                if (needPrint) {
                    window.FX.Utils._showFormPrint(a.data)
                    window.FX.Utils.showSuccessInfo(formview.element.find('.widget-wrapper'), a, function () {
                        f.remove();
                        e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
                    });
                }
                else {

                    if (a.submitPrompt.popupAutoClose) {
                        window.FX.STATIC.APPID = n.appId;
                        window.FX.STATIC.ENTRYID = n.entryId
                        f.remove();
                        if (isreload) {
                            that.reload({})
                        }
                        cb && cb();
                        return;
                    }
                    window.FX.Utils.showSuccessInfo(formview.element.find('.widget-wrapper'), a, function () {
                        f.remove();
                        e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
                    });

                }

                // needPrint && BsyUtils._showFormPrint(a.data)
            },
            onError: function (a) {
                formview.element.find('.widget-wrapper').empty();
                formview.element.find('.footer').remove();
                window.FX.Utils.showErrorInfo(formview.element.find('.widget-wrapper'), a, function () {
                    f.remove();
                    e.BBY_reportCreatForm(g, isreload, eventType, cb, opt)
                })
            },
            onAfterCancel: function () {
                f.remove();
                if (eventType == 'new') {
                    that.loadData()
                    that.loadDataCount();
                } else if (cb) {
                    cb()
                }
                window.FX.STATIC.APPID = n.appId;
                window.FX.STATIC.ENTRYID = n.entryId;
            }
        }))
    }

    componentDidMount() {
        this.allFields = [];
        this.props.fields.map((data, index) => {
            if (!data.detailOnly) {
                this.allFields.push(data);
            }
        })
        super.componentDidMount();

        if (this.props.getContext) {
            this.props.getContext(this);
        }
        if (!this.props.mountAutoLoad) {
            return
        }
        this._getStyles()
        this.loadData()
    }

    _isChartOrTable = () => {
        let t = this.props;
        return t.type == 'gantt' || t.type.indexOf("table") > -1 || t.type.indexOf("chart") > -1 || t.type.indexOf("newrili") > -1 || t.type.indexOf("card") > -1 || t.type.indexOf("newMap") > -1
    }

    _checkSubDimensionFields = () => {
        let FX = window.FX;
        let t = this.props
            , e = [].concat(t.xFields).concat(t.yFields)
            , i = [].concat(t.metrics)
            , a = !1
            , n = !1;
        return BsyUtils.forEach(e, function (t, e) {
            if (e.subform)
                return a = !0,
                    !1
        }),
            a && BsyUtils.forEach(i, function (t, e) {
                if ("formula" !== e.type && !e.subform)
                    return n = !0,
                        !1
            }),
            a && n
    }

    _checkMultipleField = () => {
        let FX = window.FX;
        let t = this.props
            , e = [].concat(t.xFields).concat(t.yFields)
            , i = 0;
        return BsyUtils.forEach(e, function (t, e) {
            if (BsyUtils.isMultipleField(e.type) && i++,
                i > 1)
                return !1
        }),
            i > 1
    }

    _checkMultipleFieldAndSubField = () => {
        let FX = window.FX;
        let t = this.props
            , e = [].concat(t.xFields).concat(t.yFields)
            , i = t.metrics
            , a = !1
            , n = !1
            , s = !1;
        return BsyUtils.forEach(e, function (t, e) {
            if (e.subform && (a = !0),
                BsyUtils.isMultipleField(e.type) && (n = !0),
                a && n)
                return !1
        }),
            n && BsyUtils.forEach(i, function (t, e) {
                if (e.subform)
                    return s = !0,
                        !1
            }),
            a && n || n && s
    }

    _checkSubCrossFields = () => {
        let FX = window.FX;
        let t = this.props
            , e = [].concat(t.xFields).concat(t.yFields).concat(t.metrics)
            , i = !1
            , a = null;
        return BsyUtils.forEach(e, function (t, e) {
            if (e.subform)
                if (a) {
                    if (a !== e.subform)
                        return i = !0,
                            !1
                } else
                    a = e.subform
        }),
            i
    }

    _renderGuide = () => {
        let t = window.$;
        let t1 = this.props;
        if (t1.type === 'gantt') {
            t('<div class="component-content component-content-guide ' + t1.type + ' "/>').append(t('<span class="guide-tip"/>').text(React.language("dash.gantt.field.add.guide"))).appendTo(t(this.dashRef.current).empty())
        }
        else
            t('<div class="component-content component-content-guide ' + t1.type + ' "/>').append(t('<span class="guide-tip"/>').text(React.language("dash.field.add.guide"))).appendTo(t(this.dashRef.current).empty())
    }

    _renderTip = (e) => {
        let t = window.$;
        let FX = window.FX;
        let tipText = BsyUtils._getWidgetTypeName(this.props.type);
        let tipIcon = BsyUtils._getWidgetTypeIcon(this.props.type);
        BsyUtils.applyFunc(this, this.widget.onRenderBackground, [], !1);
        this.widget && this.widget.renderTip ? this.$empty = this.widget.renderTip(e) : this.$empty = t('<div class="component-content component-content-empty"><div class="empty-wrapper"><i class="' + tipIcon + '"></i><div class="empty-text">' + tipText + e + "</div></div></div>").css({
            width: t(this.dashRef.current).width(),
            height: t(this.dashRef.current).height()
        }).appendTo(t(this.dashRef.current).empty())
    }

    _getInvalidConf = (t) => {
        let FX = window.FX;
        let e = this.props.emptyTip
            , i = !1;
        if (BsyUtils.isNull(t))
            return {
                tip: e,
                exception: i
            };
        switch (t) {
            case 4010:
                e = BsyUtils.isEmpty(FX.STATIC.DASH_TOKEN) ? React.language("dash.auth.noAuth") : React.language("dash.auth.errorTip");
                i = !0;
                break;
            case 4212:
                e = React.language("error.4212");
                break;
            case 4213:
                e = React.language("error.4213");
                break;
            case 4215:
                e = React.language("error.4215");
                break;
            case 4216:
                e = React.language("error.4216");
                break;
            default:
                e = React.language("dash.config.error");
                i = !0
        }
        return {
            tip: e,
            exception: i
        }
    }

    _isFieldsValid = () => {
        let FX = window.FX;
        let t = this.props;
        switch (t.type) {
            case "line_chart":
            case "column_chart":
            case "bar_chart":
            case "funnel_chart":
            case "area_chart":
            case "radar_chart":
            case "pie_chart":
            case "map_chart":
                return (t.xFields.length > 0 || t.yFields.length > 0) && t.metrics.length > 0;
            case "pivot_table":
                return (t.xFields.length > 0 || t.yFields.length > 0) && t.metrics.length > 0;
            case "multi_axes_chart":
                return t.xFields.length > 0 && t.metrics.length > 0;
            case "metric_table":
            case "gauge_chart":
                return t.metrics.length > 0;
            case "gantt":
                // return t.metrics.length > 0;

                let subofrm = undefined;
                //「开始时间」、「结束时间」、「进度」以及「维度」中子表单字段必须同属于一个子表单
                if (t.ganttFields) {
                    // if (t.ganttFields.progress) {
                    //     if (t.ganttFields.progress.subform) {
                    //         subofrm = t.ganttFields.progress.subform;
                    //     }
                    // }
                    // else
                    // {
                    //     return false;
                    // }
                    if (t.ganttFields.start) {
                        if (t.ganttFields.start.subform) {
                            subofrm = t.ganttFields.start.subform;
                        }
                    }
                    else {
                        return false;
                    }
                    if (t.ganttFields.end) {
                        if (t.ganttFields.end.subform != subofrm) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
                if (t.xFields == 0)
                    return false;
                let hasSubform = true;
                BsyUtils.forEach(t.xFields, function (a1, b1) {
                    if (b1.subform != subofrm) {
                        hasSubform = false;
                        return !1;
                    }
                })
                return hasSubform;
            case "data_table":
            case "background_table":
            case "card":
                return t.fields.length > 0;
            case "newrili":
                return t.tFields.length > 0;
            default:
                return !0
        }
    }

    _checkFieldsValid = () => {
        let t = this.props
            , e = !0;
        if (!this._isChartOrTable())
            return e;
        let i = null;
        if (this._isFieldsValid()) {
            if (this._checkSubDimensionFields()) {
                e = !1
                i = 4212
            } else if (this._checkMultipleField()) {
                e = !1
                i = 4215
            } else if (this._checkMultipleFieldAndSubField()) {
                e = !1
                i = 4216
            } else if (this._checkSubCrossFields()) {
                e = !1
                i = 4213
            }
        } else {
            if (t.showGuide)
                return this._renderGuide(),
                    !1;
            e = !1
        }


        return e || this._renderTip(this._getInvalidConf(i).tip),
            e
    }

    _triggerException = () => {
        if (this.doException) {
            this.doException(this.exception)
            this.doException = null
        }
    }

    _renderWidget = (e) => {
        let t = window.$;
        let FX = window.FX;
        let i = this
            , a = this.props;
        if (e.type) {
            if (!this._checkFieldsValid()) {

                this.exception = !1;
                void this._triggerException();
                BsyUtils.applyFunc(i, a.onLoadFail, [t, i.Refresh], !1)
                i.Refresh = undefined;
                return
            }
            let style = {};
            // if(!BsyUtils.isObjectEmpty(a.widget.styles))
            // {
            //     style = $.extend({},a.styles,{
            //         widget:a.widget.styles
            //     })
            // }
            // else
            // {
            //     style = $.extend({},a.styles)
            // }

            // this.widget = FX.createWidget(t.extend(e,{
            //     widgetName: a.widgetId,
            //     widgetId: a.widgetId,
            //     renderEl: t('<div class="component-content"/>').appendTo(t(this.dashRef.current)),
            //     hasHeader: !1,
            //     hasBorder: !1,
            //     appId:a.appId,
            //     range:a.range,
            //     pointerColor:a.pointerColor,
            //     changeMethod: a.changeMethod,
            //     entryId:a.entryId,
            //     // styles:style,
            //     dashStyles:a.dashStyles,
            //     styles:a.styles,
            //     ptlist: a.ptlist,
            //     readData: a.readData,
            //     width: t(this.dashRef.current).width(),
            //     height: t(this.dashRef.current).height(),
            //     sizeX: a.width,
            //     sizeY: a.height,
            //     ganttFields: a.ganttFields,
            //     taskIdField: a.taskIdField,
            //     taskDependenciesField:a.taskDependenciesField,
            //     zoomLevel:a.zoomLevel,
            //     chart_label:a.chart_label,
            //     drilling: a.drilling,
            //     cardConfig: a.cardConfig,
            //     formulas: a.rmulas,
            //     cardConfigFields: a.cardConfigFields,
            //     summaryTitleAlignment: a.summaryTitleAlignment,
            //     forms: a.forms,
            //     fields: a.fields,
            //     mapfields: a.mapfields,
            //     menu: a.menu,
            //     scopefields: e.scopefields,
            //     onSwitchButton: e.onSwitchButton,
            //     BtnName: e.BtnName,
            //     FunctionBtn: e.FunctionBtn,
            //     DataMode: e.DataMode,
            //     itemSeleable: e.itemSeleable,
            //     itemMarekerable: e.itemMarekerable,
            //     itemDataable: e.itemDataable,
            //     mapScale: e.mapScale,
            //     reportAuth: e.reportAuth,
            //     multipleChoice: a.multipleChoice,
            //     stickyDataMenu: a.stickyDataMenu,
            //     checkStatus: a.checkStatus,
            //     itemsPerPage: a.itemsPerPage,
            //     url:a.url,
            //     filter: a.filter,
            //     permission: a.permission,
            //     mode: a.mode,
            //     isLayoutEdit: a.isLayoutEdit,
            //     title: a.title,
            //     realtabletype: a.realtabletype,
            //     formAttr: a.formAttr,
            //     dataPerms: a.dataPerms,
            //     defaultConfig: a.defaultConfig,
            //     method: a.method,
            //     valueMode: a.valueMode,
            //     content: a.content,
            //     thresholds: "all" === a.permission ? a.thresholds : [],
            //     guideline: a.guideline,
            //     legend: a.legend,
            //     palette: a.palette,
            //     value_size: a.value_size,
            //     chartLabel: a.chartLabel,
            //     attrList: a.attrList,
            //     background: a.background,
            //     onItemClick: a.onItemClick,
            //     onClearLink: a.onClearLink,
            //     onStopEdit: a.onStopEdit,
            //     onDataFilter: a.onDataFilter,
            //     onPageSizeChange: a.onPageSizeChange,
            //     dashTitle: a.dashTitle,
            //     triggers: a.triggers,
            //     componentAttr: BsyUtils.pick(a, ["posX", "posY", "height", "width", "type", "formulas","menu","batchmenu"])
            // }))
        }
    }

    _initChartOption = (e, i, n, r) => {
        // console.log(e, i, n, r)
    }

    changeDayMenu = (d, m, y) => {
        const { month, year } = this.state
        this.setState({
            selectYear: y,
            selectMonth: m,
            selectDay: d
        }, () => {
            if (month !== m || y !== year) {
                this.loadData()
            }
        })
    }

    changeDay = (d, m, y) => {
        return () => {
            const { selectMonth, selectYear } = this.state
            this.setState({
                selectYear: y,
                selectMonth: m,
                selectDay: d
            }, () => {
                if (selectMonth !== m || y !== selectYear) {
                    this.loadData()
                }
            })
        }
    }

    changeToday = () => {
        const { newDay, newMonth, newYear, selectYear, selectMonth } = this.state;
        this.setState({
            selectYear: newYear,
            selectMonth: newMonth,
            selectDay: newDay
        }, () => {
            if (selectMonth !== newMonth || newYear !== selectYear) {
                this.loadData()
            }
        })
    }

    prevMonth = () => {
        const { selectMonth, selectYear, selectDay, vm } = this.state;
        if (vm === 0) {
            if (selectMonth === 0) {
                const numDay = this.isLeapMonth((selectYear - 1))
                this.setState({
                    selectYear: selectYear - 1,
                    selectMonth: 11,
                    selectDay: numDay[11] > selectDay ? selectDay : numDay[11]
                }, () => {
                    this.loadData()
                })
            } else {
                const numDay = this.isLeapMonth(selectYear)
                this.setState({
                    selectMonth: selectMonth - 1,
                    selectDay: numDay[selectMonth - 1] > selectDay ? selectDay : numDay[selectMonth - 1]
                }, () => {
                    this.loadData()
                })
            }
        } else {
            const timestamp1 = Date.parse(new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay));
            const timestamp2 = new Date(timestamp1 - 604800000);
            const newYear = timestamp2.getFullYear();
            const newMonth = timestamp2.getMonth();
            const newDay = timestamp2.getDate();
            this.setState({
                selectYear: newYear,
                selectMonth: newMonth,
                selectDay: newDay
            }, () => {
                this.loadData()
            })
        }
    }

    nextMonth = () => {
        const { selectMonth, selectYear, selectDay, vm } = this.state;
        if (vm === 0) {
            if (selectMonth === 11) {
                const numDay = this.isLeapMonth((selectYear + 1))
                this.setState({
                    selectYear: selectYear + 1,
                    selectMonth: 0,
                    selectDay: numDay[0] > selectDay ? selectDay : numDay[0]
                }, () => {
                    this.loadData()
                })
            } else {
                const numDay = this.isLeapMonth(selectYear)
                this.setState({
                    selectMonth: selectMonth + 1,
                    selectDay: numDay[selectMonth + 1] > selectDay ? selectDay : numDay[selectMonth + 1]
                }, () => {
                    this.loadData()
                })
            }
        } else {
            const timestamp1 = Date.parse(new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay));
            const timestamp2 = new Date(timestamp1 + 604800000);
            const newYear = timestamp2.getFullYear();
            const newMonth = timestamp2.getMonth();
            const newDay = timestamp2.getDate();
            this.setState({
                selectYear: newYear,
                selectMonth: newMonth,
                selectDay: newDay
            }, () => {
                this.loadData()
            })
        }
    }

    changeMonthYear = (y, m) => {
        const { selectDay } = this.state;
        const numDay = this.isLeapMonth(y);
        this.setState({
            selectYear: y,
            selectMonth: m,
            selectDay: numDay[m] > selectDay ? selectDay : numDay[m]
        }, () => {
            this.loadData()
        })
    }

    changeMonthYearPane = (event) => {
        const { selectMonth, selectYear, selectDay, vm } = this.state;
        BsyMsgBubble({
            anchor: event.currentTarget,
            contentHTML: (ref) => {
                return <BsyMonthYearPane changeDayMenu={this.changeDayMenu}
                    mode={vm === 0 ? "monthMode" : "dayMode"}
                    ref={ref} year={selectYear} month={selectMonth}
                    day={selectDay} changeMonthYear={this.changeMonthYear} />
            },
            text4Cancel: null,
            text4Ok: null,
            theme: this.props.theme,
            minWidth: 280,
            width: 280,
            contentPadding: 0,
            edge: 200,
            hAdjust: 72,
            dockPosition: "center",
            onClose: function () {
                return !1;
            }
        })
    }

    changeVM0 = () => {
        this.setState({
            vm: 0
        }, () => {
            this.loadData()
        })
    }

    changeVM1 = () => {
        this.setState({
            vm: 1
        }, () => {
            this.loadData()
        })
    }

    numAdd0 = (num) => {
        let n = num;
        if (num <= 9 && num > 0) {
            n = "0" + num
        }
        return n
    }

    _getShowFieldKey = () => {
        const { appId, entryId, widgetId } = this.state;
        return BsyUtils.Store.getKey("dashboardShowFields", {
            appId: appId,
            entryId: entryId,
            widgetId: widgetId,
        })
    }

    _updateCachedFields = () => {
        const { headerData } = this.state
        BsyUtils.Store.set(this._getShowFieldKey(), headerData)
        this.loadData()
    }

    BBY_doSetFields = (t) => {
        let e = this;
        let { headerData } = this.state
        if (!BsyUtils.isNull(headerData)) {
            let i = BsyUtils.getShowFieldItems(headerData, this.allFields);
            if (e.setField) {
                e.setField._onTriggerClick();
                e.setField.triggerView.css(BsyUtils._calTriggerViewPos(t, {
                    width: 240,
                    height: 200
                }));
                return;
            }
            e.setField = new window.FX.ComboCheckBox({
                renderEl: window.$(t.target),
                items: i,
                width: null,
                height: null,
                // dashStyles: e.options.dashStyles,
                onElementCreate: function () {
                    return !0
                },
                onAfterTriggerHide: function () {
                    e.setState({
                        headerData: BsyUtils.getShowFieldsByNames(e.allFields, this.getValue())
                    }, () => {
                        e._updateCachedFields();
                    })
                },
                onAfterItemCreate: function (t, e, i) {
                    i.addClass(t.cls)
                }
            });
            e.setField._onTriggerClick();
            e.setField.triggerView.css(BsyUtils._calTriggerViewPos(t, {
                width: 240,
                height: 200
            }));
        }
    }

    reload = () => {
        this.loadData()
    }

    loadData = (n, d) => {

        let autoload = this.props.autoLoad;
        if (this.props.onIsAutoLoad)
            autoload = this.props.onIsAutoLoad()

        if (!autoload) {
            return
        }
        this.isDashFull = n;
        let i = this.props;
        let url = "/data/report_rili_list";
        if (this.state.mode === "edit") {
            url = "/data/report_preview_rili_list";
        }

        const { selectDay, selectMonth, selectYear, vm } = this.state;
        const date = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDateTitle1 = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDateTitle2 = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const monthDayNum = this.isLeapMonth(selectYear)[selectMonth]
        let endT = "";
        let startT = "";
        date.setDate(1);
        date.setDate(date.getDate() + 2);
        newDateTitle1.setDate(newDateTitle1.getDate() - (7 & newDateTitle1.getDay()) + 1);
        newDateTitle2.setDate(newDateTitle2.getDate() - (7 & newDateTitle2.getDay()) + 7);

        if (vm === 0) {
            startT = date.getFullYear() + "/" + this.numAdd0((date.getMonth() + 1)) + "/" + this.numAdd0(1)
            endT = date.getFullYear() + "/" + this.numAdd0((date.getMonth() + 1)) + "/" + this.numAdd0(monthDayNum)
        } else {
            startT = newDateTitle1.getFullYear() + "/" + this.numAdd0((newDateTitle1.getMonth() + 1)) + "/" + this.numAdd0(newDateTitle1.getDate())
            endT = newDateTitle2.getFullYear() + "/" + this.numAdd0((newDateTitle2.getMonth() + 1)) + "/" + this.numAdd0(newDateTitle2.getDate())
        }
        this.setState({
            loading: true,
        }, () => {
            React.axios(url, {
                appId: i.appId,
                endT: endT,
                entryId: i.entryId,
                startT: startT,
                widgetId: i.widgetId,
                filter: this.getFilterData(this.filterParam),
            }, { dashMode: n }).then((res) => {

                if (res.data.hasOwnProperty('code') && res.data.code === 3000) {
                    //onConfigError
                    if (this.props.onConfigError) {
                        this.props.onConfigError(res.data)
                    }
                    if (this.props.onLoadFail) {
                        this.props.onLoadFail(n, d)
                    }
                    return;
                }

                let headerName = []
                let showFields = BsyUtils.Store.get(this._getShowFieldKey())
                if (showFields) {
                    showFields.map((res) => {
                        if (res.type === 'subform') {
                            res.items.map((res1) => {
                                headerName.push([res.name, res1.name].join('.'))
                            })
                        } else {
                            headerName.push(res.name)
                        }
                    })
                } else {
                    res.data.header.map((res) => {
                        if (!res.detailOnly) {
                            if (res.type === 'subform') {
                                res.items.map((res1) => {
                                    if (!res1.detailOnly) {
                                        headerName.push([res.name, res1.name].join('.'))
                                    }
                                })
                            } else {
                                headerName.push(res.name)
                            }
                        }
                    })
                }
                this.setState({
                    dateData: res.data.data,
                    headerData: BsyUtils.getShowFieldsByNames(res.data.header, headerName),
                    reftype: res.data.reftype,
                    loading: false,
                }, () => {
                    if (this.props.onLoadSuccess) {
                        this.props.onLoadSuccess(res.data, n, d)
                    }
                })
            }).catch((res) => {
                if (this.props.onLoadFail) {
                    this.props.onLoadFail(n, d)
                }
                this.setState({

                    loading: false,
                })
            })
        })

    }

    previewImg = (e, header, url) => {
        let that = this;
        const { hasPreview, previewHeight, previewWidth } = header
        if (!hasPreview) {
            return;
        }
        if (!url) {

            this.floatLayout = document.querySelectorAll('.bsy-float-preview-img');

            if (this.floatLayout) {
                for (let index = 0; index < this.floatLayout.length; index++) {
                    const element = this.floatLayout[index];
                    if (element) {
                        element.remove();
                    }
                }
            }
            this.floatLayout = null;
            return;
        }
        let width = previewWidth;
        let height = previewHeight
        if (!this.floatLayout) {
            this.floatLayout = document.createElement('div');
            this.floatLayout.classList.add("bsy-float-preview-img");
            document.body.appendChild(this.floatLayout)
            resize('hidden');
            var image = new Image(); //创建一个image对象
            image.src = url;   //新创建的image添加src
            image.onload = function () {
                // console.log(this.naturalWidth,this.naturalHeight)
                width = this.naturalWidth;
                if (width > previewWidth) {
                    width = previewWidth;
                }
                height = this.naturalHeight;
                if (height > previewHeight) {
                    height = previewHeight;
                }
                resize('');
            }
            this.floatLayout.appendChild(image)
        }

        function resize(display, image) {
            if (!that.floatLayout)
                return;

            const { top, left } = BsyUtils.elemoffset(e.target);
            height = that.floatLayout.offsetHeight;
            // console.log(top, left)
            // console.log(height)
            // console.log(that.floatLayout.offsetHeight);

            let css = {
                width: width + 'px',
            }

            if (height > top) {
                //底部有足够的空间
                css.top = 0 + 'px';
            } else {
                css.top = (top - height - 26) + 'px';
            }

            // else {
            //     css.bottom = document.documentElement.clientHeight - top + 2 + 'px'
            // }

            if (width > left || document.documentElement.clientWidth - left - 10 > width) {
                //右边有足够的空间
                css.left = left + e.target.offsetWidth + 10 + 'px';
            } else {
                css.left = left - width - 10 + 'px';
            }


            // console.log(css)
            that.floatLayout.style.zIndex = window.FX.STATIC.zIndex++;
            that.floatLayout.style.left = css.left;
            that.floatLayout.style.maxWidth = previewWidth + 'px';
            that.floatLayout.style.maxHeight = previewHeight + 'px';
            that.floatLayout.style.bottom = css.bottom ? css.bottom : "auto";
            that.floatLayout.style.top = css.top ? css.top : "auto";
            that.floatLayout.style.visibility = display;
        }
    }

    transformDataSourceRow = (header, data, dataId) => {
        const { appId, dateData, selectYear, selectMonth, selectDay } = this.state;
        if (!header)
            return data;
        if (data === undefined) {
            return undefined;
        }
        if (BsyUtils.isObjectEmpty(data)) {
            return '';
        }
        switch (header.type) {
            case "image": {
                let dd = [];
                try {
                    dd = data
                } catch (error) {
                    dd = [];
                }
                let hasPreview = true;
                let hasTooltip = false;
                if (header.type === "upload") {
                    hasPreview = false;
                    hasTooltip = true;

                } else {
                    hasPreview = header.preview === undefined ? !0 : header.preview;
                }

                let auth = {
                    is_file_down: false,
                };
                let m = (selectMonth + 1) < 10 ? ("0" + (selectMonth + 1)) : (selectMonth + 1);
                let d = selectDay < 10 ? ("0" + selectDay) : selectDay;
                let rowData = dateData[selectYear] ? dateData[selectYear][m] ? dateData[selectYear][m][d] ? dateData[selectYear][m][d] : [] : [] : [];
                dataId = dataId ? dataId : header.rowDataId;
                // eslint-disable-next-line array-callback-return
                rowData && rowData.map(res => {
                    if (dataId === res._id) {
                        let f = res.optAuth[header.subform ? (header.subform + "." + header.name) : header.name];
                        auth.is_file_down = f.is_file_down;
                    }
                })

                return <BsyThumbList
                    widget={header}
                    hasPreview={hasPreview}
                    hasTooltip={hasTooltip}
                    appId={appId}
                    dataId={dataId}
                    is_file_down={auth.is_file_down}
                    formId={header.form}
                    files={dd} />
            }

            case "signature": {
                let dd = [];
                try {
                    dd = data
                } catch (error) {
                    dd = [];
                }
                let hasPreview = true;
                let hasTooltip = false;

                if (header.type === "upload") {
                    hasPreview = false;
                    hasTooltip = true;

                } else {
                    hasPreview = header.preview === undefined ? !0 : header.preview;
                }

                return <BsyThumbList
                    widget={header}
                    hasPreview={hasPreview}
                    hasTooltip={hasTooltip}
                    appId={appId}
                    dataId={dataId}
                    formId={header.form}
                    files={dd} />
            }
            case "upload": {
                let dd = [];
                try {
                    if (BsyUtils.isString(data)) {
                        dd = JSON.parse(data)
                    } else
                        dd = data
                } catch (error) {
                    dd = [];
                }
                let auth = {
                    is_file_down: false,
                    online_edit: false,
                };
                let m = (selectMonth + 1) < 10 ? ("0" + (selectMonth + 1)) : (selectMonth + 1);
                let d = selectDay < 10 ? ("0" + selectDay) : selectDay;
                let rowData = dateData[selectYear] ? dateData[selectYear][m] ? dateData[selectYear][m][d] ? dateData[selectYear][m][d] : [] : [] : [];
                dataId = dataId ? dataId : header.rowDataId;
                // eslint-disable-next-line array-callback-return
                rowData && rowData.map(res => {
                    if (dataId === res._id) {
                        let f = res.optAuth[header.subform ? (header.subform + "." + header.name) : header.name];
                        auth.is_file_down = f.is_file_down;
                        auth.online_edit = f.online_edit;
                    }
                })
                return <BsyFileThumbList
                    fieldName={header.name}
                    appId={appId}
                    dataId={dataId}
                    widget={header}
                    formId={header.form}
                    files={dd}
                    is_file_down={auth.is_file_down}
                    online_edit={auth.online_edit}
                    popupFormPath={this.popupFormPath}
                    formMode={false}
                    isRili={true}
                />
            }
            case "usergroup":
            case "deptgroup":
                let o = [];
                BsyUtils.forEach(data, function (a, b) {
                    if (b)
                        o.push(BsyUtils._toDeptUser(b))
                })
                return o.join(",");
            case "user":
            case "dept":
                return BsyUtils._toDeptUser(data);
            case 'linkdata': {

                if (header.linkType === 'number') {
                    let d = data ? data.key : ''
                    let res = BsyUtils.numberFormatValue(d, header);
                    const afterSuffixVal = getAfterSuffix(header.afterSuffix)
                    if (afterSuffixVal && res.text && !res.text.includes("%")) {
                      res.text =  res.text + ' ' + afterSuffixVal;
                    } 
                    return res.text;
                }
                return data ? data.key : '';
            }
            case "assist_flowid":
                return data && data.flowName;
            case "assist_prostatus": {
                return data && data.text;
            }
            case "number":
                if (data) {
                    let res = {
                        value: '',
                        text: '',
                    }
                    if (['assist_protime', 'assist_outtime'].includes(header.name)) {
                        res = BsyUtils.numberFormatTime(data, header)
                    } else {
                        res = BsyUtils.numberFormatValue(data, header);
                        const afterSuffixVal = getAfterSuffix(header.afterSuffix)
                        if (afterSuffixVal && res.text && !res.text.includes("%")) {
                            res.text = res.text + " " + afterSuffixVal;
                        }
                    }
                    return res.text;
                }
                // return BsyUtils.num2Str(data, header.format)
                return '';
            case "datetime":
                if (data)
                    return BsyUtils.date2Str(dayjsUtils.timeToTZ(data), header.format)
                return '';
            case "address":
            case "location": {
                return BsyUtils.address2Str(data, header.format || 'pcda')
            }
            case 'flowstate':
            case 'flowState': {
                return BsyUtils._getFlowState(data);
            }
            case 'flowdecision':
            case 'flowDecision': {
                if (data) {
                    if (data.state) {
                        return data.state
                    }
                }
                return ''
            }
            case "checkboxgroup":
            case "combocheck":
                if (header.colorEnable) {
                    return <BsyTagList height={this.state.vm === 1 ? "47px" : ""} header={header} data={data} />
                } else {
                    return data.join(",");
                }
            case "radiogroup":
            case "combo":
                if (header.colorEnable) {
                    return <BsyTagList header={header} data={data} />
                } else {
                    if (!data) {
                        data = "";
                    }
                    return data
                }
            case "chargers":
                let m = {}
                    , n = {};
                BsyUtils.forEach(data, function (a, b) {
                    if (b.flowName) {
                        m[b.flowName] || (m[b.flowName] = !0)
                        n[b.userNickname] || (n[b.userNickname] = !0)
                    }
                });

                let outdata = {
                    currentnode: [],
                    currentcharger: [],
                };
                BsyUtils.forEach(m, function (a) {
                    outdata.currentnode.push(a)
                })
                BsyUtils.forEach(n, function (a) {
                    outdata.currentcharger.push(a)
                })
                return outdata;
            case "textarea":
                return <pre>{data}</pre>;
            default:
                return data;
        }
    }

    _doShowData = (b, i) => {
        if ("visit" === this.state.mode) {
            this._dataIndex = b;
            this._doshowData(b, 'rili', i);
        }
    }
    _doshowData = (b, type, animation, lowLayer) => {
        //报表编辑  数据表编辑  数据管理数据编辑都走这里 改方法需要根据类型type做针对处理 zhxj 190319
        const $ = window.$;
        const FX = window.FX;
        let c = this.data[b];
        let a = this;
        let that = this;
        let extDashData = {
            appId: this.props.appId,
            entryId: this.props.entryId,
            formId: this.props.forms[0],
            widgetId: this.props.widgetId,
        }
        let layerRef = null;
        if (c) {
            let d = this.props
                , e = this
                , f = c._id
                , o = d.fields
                , h = d.title
                , i = $('<div class="x-window-mask modal light"/>').css({
                    "z-index": FX.STATIC.zIndex++
                });
            d.itemPrintable = d.hasOwnProperty("itemPrintable") ? d.itemPrintable : !0;
            d.itemEditable = d.hasOwnProperty("itemEditable") ? d.itemEditable : !0;
            d.itemRemovable = d.hasOwnProperty("itemRemovable") ? d.itemRemovable : !0;
            d.itemAddable = d.hasOwnProperty("itemAddable") ? d.itemAddable : !1;
            let hasCopy =  c.dataPerms ? c.dataPerms.copy : false;
            let hasEditBtn = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.update : d.itemEditable),
                hasDeleteBtn = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.delete : d.itemRemovable),
                hasLog = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.log : d.itemLog),
                hasComment = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.comment : d.itemComment),
                hasFlowLog = c.dataPerms ? c.dataPerms.flow_log : d.flow_log;



            if (a.state.reftype === 'etl_table' || a.state.reftype === 'aggregate_table') {

                let config = {

                    appId: d.appId,
                    entryId: d.entryId,
                    formId: d.formId,
                    origin: "report",
                    originPrint: "report",
                    forms: d.forms,
                    fields: o,
                    ptlist: [],
                    width: 1080,
                    header: o,
                    multiTabs: d.multiTabs,
                    hasShareBtn: !1,
                    layout: d.formLayout,
                    data: c,
                    optAuth: c.optAuth,
                    hasShowFieldsBtn: d.hasShowFieldsBtn || d.needFetchViewData,
                    title: h,
                    allShowFields: d.showFields,
                    height: "100%",
                    sourceType: d.type,
                    hasFlowBtn: d.hasFlow && !d.hasRecoverBtn,
                    hasPrintBtn: d.itemPrintable,
                    hasEditBtn: hasEditBtn,
                    hasDeleteBtn: hasDeleteBtn,
                    hasAddBtn: d.itemAddable,
                    hasLog: d.isEtlTable ? false : hasLog,
                    hasComment: d.isEtlTable ? false : hasComment,
                    hasFlowLog: d.isEtlTable ? false : hasFlowLog,
                    hasRecoverBtn: d.hasRecoverBtn,
                    dataPerms: c.dataPerms,
                    flow_activate: d.ignoreOptAuth || d.flow_activate !== !1,
                    flow_close: d.ignoreOptAuth || d.flow_close !== !1,
                    flow_transfer: d.ignoreOptAuth || d.flow_transfer !== !1,
                    hasSwitchBtn: !0,
                    dataIndex: b + 1,
                    dataCount: a.data.length,
                    authGroupId: d.authGroupId,
                    //hasCustomPrint: d.ignoreOptAuth || d.authGroupId,
                    hasCustomPrint: !0,

                    onSwitchData: function (a, b) {
                        let c = e.data[a - 1];
                        return c;
                    },
                    onDeleteData: function () {
                        BsyAlert({
                            title: React.language("del.data.tip"),
                            type: "error",
                            text4Ok: React.language("ok"),
                            text4Cancel: React.language("cancel"),
                            OkType: "red",
                            ok: function () {
                                e.doDeleteData(f, type);
                                layerRef && layerRef.close();
                            }
                        })
                    },

                }

                BsyMaskLayer({
                    customCls: animation ? 'fadein-right' : '',
                    onMaskClick: (event) => {
                        // if (event.target.classList.contains("BsyMaskLayer")) {
                        //   layerRef.close();
                        // }
                    },
                    onContentCreate: (ref) => {
                        layerRef = ref;

                        return <BsyFormPane
                            {...config}
                            mode={'view'}
                            entrance={"report"}
                            onClose={(status, reshow) => {
                                layerRef && layerRef.close();
                                if (status) {
                                    that.setState({
                                        // skip: 0,
                                    }, () => {
                                        that.loadWidget();
                                    })
                                }
                            }}
                        />

                    }
                })
                lowLayer && lowLayer.close();

                return;
            }



            let d1 = BsyUtils.checkRefApp({
                appId: d.appId,
                entryId: d.entryId,
                formId: d.forms[0],
                dataId: c._id,
                iseditable: !1,
                fields: d.fields,
                formulas: d.formulas,
                popupFormPath: e.popupFormPath.concat({
                    appId: e.props.appId,
                    entryId: e.props.entryId,
                    formId: e.props.forms[0],
                    widgetId: e.props.widgetId,
                }),
            });
            const { restore } = BsyUtils.globalIdManager(d1.appId, d1.entryId);
            if (this.props.widgetId) {
                d1 = { ...d1, widgetId: this.props.widgetId };
            }
        
            window.FX.Utils.dataAjax({
                url: "/data/read",
                data: d1
            }, function (g) {

                let fieldtabs = {};
                BsyUtils.forEach(g.form.items, function (a1, b1) {
                    if (b1.tab)
                        fieldtabs[b1.widget.widgetName] = b1.tab
                })
                let newdata = {};
                let fields = [];
                let o1 = a._parseFieldLabelFormat(d.fields, g.form.items);
                BsyUtils.forEach(o1, function (a1, b1) {
                    let tmpdata = $.extend({}, b1);

                    if (["dataload", 'button'].indexOf(b1.type) > -1) {
                        return !0;
                    }

                    if (fieldtabs.hasOwnProperty(b1.name)) {
                        tmpdata.tab = fieldtabs[b1.name];
                    }
                    fields.push(tmpdata);
                    newdata[b1.tag] = g.data[b1.name];
                })
                newdata["_id"] = g.data["_id"];
                if (g.hasCoop || !g.hasFlow) {
                    hasFlowLog = !1;
                }
                if (hasFlowLog) {
                    newdata["flowStack"] = g.data["flowStack"];
                    newdata["flowState"] = g.data["flowState"];
                    newdata["chargers"] = g.data["chargers"];
                    newdata["flowVer"] = g.data["flowVer"];
                }
                newdata = $.extend(newdata, g.data);
                newdata.optAuth = c.optAuth;
                let config = {
                    // renderEl: $("<div class='x-shadow-content'/>").appendTo(i.appendTo("body")),
                    appId: d1.appId,
                    refAppId: d1.refAppId,
                    entryId: d1.entryId,
                    formId: d1.formId,
                    origin: "report",
                    originPrint: "report",
                    hasCopy:hasCopy,
                    forms: d.forms,
                    rawdata: a.props.rawdata,
                    extDashData: a.props.rawdata ? extDashData : null,
                    widgetId: a.props.widgetId,
                    items: g.form.items,
                    fieldShowRules: g.form.fieldShowRules,
                    subformFieldShowRules: g.form.subformFieldShowRules,
                    is_dock_form: g.is_dock_form,
                    fields: d.fields,
                    form: g.form,
                    header: fields,
                    allShowFields: o1,
                    optAuth: c.optAuth,
                    ptlist: d.isEtlTable ? [] : c.dataPerms && c.dataPerms.ptlist,
                    multiTabs: g.formTabs,
                    formTabsStyle: g.formTabsStyle || {},
                    hasShareBtn: !1,
                    layout: d.formLayout,
                    data: newdata,
                    dataId: c._id,
                    hasShowFieldsBtn: d.hasShowFieldsBtn || d.needFetchViewData,
                    title: h,
                    width: 1080,
                    hasFlowLog: hasFlowLog,
                    hasLogView:  hasFlowLog,
                    hasFlowBtn: hasFlowLog,
                    hasPrintBtn: d.itemPrintable,
                    hasEditBtn: hasEditBtn,
                    hasDeleteBtn: hasDeleteBtn,
                    hasAddBtn: d.itemAddable,
                    hasLog: d.isEtlTable ? false : hasLog,
                    hasComment: d.isEtlTable ? false : hasComment,
                    // hasFlowLog: d.isEtlTable ? false : hasFlowLog,
                    hasRecoverBtn: d.hasRecoverBtn,
                    flow_activate: d.ignoreOptAuth || d.flow_activate !== !1,
                    flow_close: d.ignoreOptAuth || d.flow_close !== !1,
                    flow_transfer: d.ignoreOptAuth || d.flow_transfer !== !1,
                    hasSwitchBtn: !0,
                    sourceType: d.type,
                    dataIndex: b + 1,
                    dataCount: a.data.length,
                    authGroupId: d.authGroupId,
                    //hasCustomPrint: d.ignoreOptAuth || d.authGroupId,
                    hasCustomPrint: !0,
                    dataPerms: c.dataPerms,
                    popupFormPath: e.popupFormPath.concat({
                        appId: e.props.appId,
                        entryId: e.props.entryId,
                        formId: e.props.forms[0],
                        widgetId: e.props.widgetId,
                    }),
                    onSwitchData: function (a, b) {
                        that.doShowData(a - 1, null, null, false, layerRef)
                        // let c = e.data[a - 1];
                        // return c
                    },
                    onDeleteData: function () {
                        BsyAlert({
                            title: React.language("del.data.tip"),
                            type: "error",
                            text4Ok: React.language("ok"),
                            text4Cancel: React.language("cancel"),
                            OkType: "red",
                            ok: function () {
                  
                                e.doDeleteData(f, type);
                                restore();
                                layerRef && layerRef.close();
                            }
                        })
                    },
                }
                let layerRef = null;
                BsyMaskLayer({
                    customCls: 'fadein-right',
                    onMaskClick: (event) => {
                        // if (event.target.classList.contains("fadein-right")) {
                        //   layerRef.close();
                        // }
                    },
                    onContentCreate: (ref) => {
                        layerRef = ref;
                        return <BsyFormPane
                            {...config}
                            mode={'view'}
                            entrance={"report"}
                            onClose={status => {
                                restore();
                                layerRef && layerRef.close();
                                if (status) {
                                    that.loadData()
                                }
                            }}
                        />

                    }
                })
            }, function () {
                restore();
                layerRef && layerRef.close();
                return !1;
            }, function () {
                restore();
                layerRef && layerRef.close();
            })


        }
    }
    _doEditData = (b, c, type, r) => {
        const a = window.$;
        const $ = window.$;
        const FX = window.FX;
        if (b) {
            r.find('.widget-wrapper').length && r.find('.widget-wrapper').hide();
            r.find('.log-wrapper').length && r.find('.log-wrapper').hide();
            let d = this.props
                , e = this
                , f = a('<div class="x-window-mask"/>').css({
                    "z-index": FX.STATIC.zIndex++
                }).appendTo("body");
            let d1 = BsyUtils.checkRefApp({
                appId: d.appId,
                entryId: d.entryId,
                formId: d.forms[0],
                dataId: b,
                popupFormPath: e.popupFormPath.concat({
                    appId: e.props.appId,
                    entryId: e.props.entryId,
                    formId: e.props.forms[0],
                    widgetId: e.props.widgetId,
                }),
            });
            let c = this.data[this._dataIndex];
            d.itemPrintable = d.hasOwnProperty("itemPrintable") ? d.itemPrintable : !0;
            d.itemEditable = d.hasOwnProperty("itemEditable") ? d.itemEditable : !0;
            d.itemRemovable = d.hasOwnProperty("itemRemovable") ? d.itemRemovable : !0;
            d.itemAddable = d.hasOwnProperty("itemAddable") ? d.itemAddable : !1;
            let hasEditBtn = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.update : d.itemEditable),
                hasDeleteBtn = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.delete : d.itemRemovable),
                hasLog = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.log : d.itemLog),
                hasComment = d.ignoreOptAuth || (c.dataPerms ? c.dataPerms.comment : d.itemComment),
                flow_log = c.dataPerms ? c.dataPerms.flow_log : d.flow_log;

            let t11 = window.FX.Utils.createLoadLayer("body", {
                isLight: !1,
                hasLoader: !0
            });
            if (this.props.widgetId) {
                d1 = { ...d1, widgetId: this.props.widgetId };
            }
            window.FX.Utils.dataAjax({
                url: "/data/read",
                data: d1
            }, function (g) {
                FX.STATIC.IS_EVENT = g.isEvent === true;
                if ((d.hasOwnProperty('origin') || d.hasOwnProperty('chartType')) && (d.origin === 'dash' || d.chartType === "rili")) {
                    //2022 12 17 查询原始数据改动 直接走后端权限，前端不需要重装判断了
                    d.optAuth = { ...c.optAuth }
                    //报表 可编辑权限根据报表设计走
                    // BsyUtils.forEach(d.fields, function (index, field) {
                    //     d.optAuth = d.optAuth || [];
                    //     d.optAuth[field.name] = {
                    //         enable: field.hasOwnProperty('isEditable') ? field.isEditable : true, visible: true
                    //     };
                    //     if (field.type === 'subform') {
                    //         a.extend(d.optAuth[field.name], {
                    //             subform_create: field.hasOwnProperty('subform_create') ? field.subform_create : true,
                    //             subform_delete: field.hasOwnProperty('subform_delete') ? field.subform_delete : true,
                    //             subform_edit: field.hasOwnProperty('subform_edit') ? field.subform_edit : true,
                    //             subform_import: field.hasOwnProperty('subform_import') ? field.subform_import : true,
                    //             subform_dataload: field.hasOwnProperty('subform_dataload') ? field.subform_dataload : true
                    //         });
                    //         BsyUtils.forEach(field.items, function (ind, subfield) {
                    //             d.optAuth[[field.name, subfield.name].join(".")] = {
                    //                 enable: subfield.hasOwnProperty('isEditable') ? subfield.isEditable : true, visible: true
                    //             }
                    //         })
                    //     }
                    // });
                    //有权限组值才会走 判断
                    d.authGroupId = 0;
                }

                if (g.hasCoop || !g.hasFlow) {
                    flow_log = !1;
                }


                let optAuth = $.extend({}, d.optAuth)

                if (g.hasOwnProperty("optAuth")) {
                    optAuth = $.extend({}, optAuth, g.optAuth)
                }

                new FX.Form(a.extend(g.form, {
                    renderEl: a("<div class='x-shadow-content'/>").appendTo(f.addClass(" modal light")),
                    appId: e.props.appId,
                    entryId: e.props.entryId,
                    formId: e.props.forms[0],
                    dataId: b,
                    multiTabs: d.multiTabs || g.formTabs,
                    formTabsStyle: g.formTabsStyle || {},
                    customCls: "more-btn",
                    submitUrl: "/data/update",
                    submitData: {
                        dataId: b
                    },
                    width: 1080,    //数据编辑状态下 都是 1080 只有数据提交才有 780
                    title: g.formName,
                    hasFlow: !g.hasCoop && g.hasFlow,
                    hasLogView: !g.hasCoop && g.hasFlow && g.hasLogView,
                    hasLog: hasLog,
                    hasFlowLog: flow_log,
                    hasComment: hasComment,
                    is_dock_form: g.is_dock_form,
                    height: "100%",
                    tabs: g.tabs,
                    submitText: React.language("modify"),
                    cancelText: React.language("cancel"),
                    ignoreOptAuth: BsyUtils.isObjectEmpty(optAuth) ? d.ignoreOptAuth : !1, //数据管理中当出现
                    ignoreValidate: d.ignoreValidate,
                    widgetOptAuth: optAuth,//d.optAuth || g.optAuth,
                    authGroupId: d.authGroupId,
                    editValue: g.data,
                    mode: "edit",
                    // buttonPosition: "middle",
                    popupFormPath: e.popupFormPath.concat({
                        appId: e.props.appId,
                        entryId: e.props.entryId,
                        formId: e.props.forms[0],
                        widgetId: e.props.widgetId,
                    }),
                    onSuccess: function (a) {
                        r && r.remove();
                        f.remove();
                        e.loadData()
                    },
                    onAfterCancel: function () {
                        r && r.remove();
                        f.remove();
                        FX.STATIC.APPID = d.appId;
                        FX.STATIC.ENTRYID = d.entryId;
                    }
                }))
            }, function () {
                r && r.remove();
                f.remove();
                return !1;
            }, function () {
                r && r.remove();
                t11.remove();
            })
        }
    }

    doDeleteData = (a, type) => {
        const FX = window.FX;
        let b = this.props
            , c = this;
        let d = {
            appId: c.props.appId,
            entryId: c.props.entryId,
            formId: c.props.forms[0],
            idList: [a],
            popupFormPath: c.popupFormPath.concat({
                appId: c.props.appId,
                entryId: c.props.entryId,
                formId: c.props.forms[0],
                widgetId: c.props.widgetId,
            }),
        };
        d = BsyUtils.checkRefApp(d);
        window.FX.Utils.dataAjax({
            url: "/data/remove",
            data: d
        }, function (data) {
            if (data.msg) {
                //给后端_form事件用  返回真的时候有提示信息也要提示 zhxj 19521
                FX.Msg.toast({
                    type: "success",
                    msg: data.msg
                })
            }
            c.loadData()
        })
    }

    createBlockItems = (res, res1) => {
        let formData = this.transformDataSourceRow(res1, res[res1.tag || res1.name], res._id);

        if (res1.isdel) {
            return <div className="block-item">
                <div className="titleDate">
                    {
                        res1.title
                    }
                </div>
                <div className="item-content cell-no-auth">
                    {
                        React.language('field.no_view_auth')
                    }
                </div>
            </div>
        }

        return res1.detailOnly ? "" : res1.type !== "chargers" ? <div className="block-item">
            <div className="titleDate">
                {
                    res1.title
                }
            </div>
            {
                res1.type !== "subform" ? <div className="item-content">
                    {
                        formData
                    }
                </div> : <>
                    {
                        res1.items.length > 0 && res1.items.map((res2) => {
                            return formData && formData.length > 0 && formData.map((res3) => {
                                res2.subform = res1.name;
                                res2.form = res1.form;
                                res2.subformDataId = res3.id;
                                res2.subformWidgetName = res1.name;
                                res2.rowDataId = res._id;
                                return this.createBlockItems(res3, res2)
                            })
                        })
                    }
                </>
            }
        </div> : <>
            <div className="block-item">
                <div className="titleDate">
                    {
                        React.language("flow.node.current")
                    }
                </div>
                <div className="item-content">
                    {
                        formData && formData.currentnode && formData.currentnode.join(",")
                    }
                </div>
            </div>
            <div className="block-item">
                <div className="titleDate">
                    {
                        React.language("flow.charger.current")
                    }
                </div>
                <div className="item-content">
                    {
                        formData && formData.currentcharger && formData.currentcharger.join(",")
                    }
                </div>
            </div>
        </>
    }

    render() {
        const { widgetId, newDay, newMonth, newYear, selectDay, selectMonth, selectYear, vm, dateData, headerData, loading } = this.state;
        const date = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDate = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDate2 = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDateTitle1 = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        const newDateTitle2 = new Date(selectYear + "/" + (selectMonth + 1) + "/" + selectDay);
        let y = 0;
        let w = 0;
        let w2 = 0;
        let data = [];
        if (dateData[selectYear]) {
            if (dateData[selectYear][this.numAdd0(selectMonth + 1)]) {
                if (dateData[selectYear][this.numAdd0(selectMonth + 1)][this.numAdd0(selectDay)]) {
                    data = dateData[selectYear][this.numAdd0(selectMonth + 1)][this.numAdd0(selectDay)]
                    this.data = data
                }
            }
        }
        let isAutoRefresh = (this.props.autoRefresh && (this.props.autoRefresh && this.props.autoRefresh.enabled));
        date.setDate(1);
        date.setDate(0 - (7 & date.getDay()));
        date.setDate(date.getDate() + 2);
        newDate.setDate(newDate.getDate() - (7 & newDate.getDay()) + 1);
        newDate2.setDate(newDate2.getDate() - (7 & newDate2.getDay()) + 1);
        newDateTitle1.setDate(newDateTitle1.getDate() - (7 & newDateTitle1.getDay()) + 1);
        newDateTitle2.setDate(newDateTitle2.getDate() - (7 & newDateTitle2.getDay()) + 7);
        let bgColorFilter = this.props.bgColorFilter;
        let that = this;
        return (
            <div ref={this.dashRef}
                className={'bsy-chart-body'}
                key={widgetId}
            >
                {/* {
                    !isAutoRefresh && loading && <BsySLoading mode={'skeletonspin'} />
                } */}
                <div className="bsy-calendar" >
                    <div className="header-calendar">
                        <div className="nav">
                            <div className={"menu-btn prev" + (selectYear === this.minYear ? " notAllowed" : "")} onClick={this.prevMonth}>
                                <i className="icon-bsy-left" />
                            </div>
                            <div className="menu-btn text" onClick={this.changeMonthYearPane}>
                                <span>
                                    {vm === 0 ? (this.monthArray[selectMonth] + ", " + selectYear) : (React.language("date.month_day", { month: (newDateTitle1.getMonth() + 1), day: (newDateTitle1.getDate()) }) + " - " + React.language("date.month_day", { month: (newDateTitle2.getMonth() + 1), day: (newDateTitle2.getDate()) }))}
                                </span>
                            </div>
                            <div className={"menu-btn next" + (selectYear === this.maxYear ? " notAllowed" : "")} onClick={this.nextMonth}>
                                <i className="icon-bsy-right" />
                            </div>
                            <div className="menu-btn today" onClick={this.changeToday}>
                                {
                                    vm === 0 ? React.language("today") : React.language("date.thisWeek")
                                }
                            </div>
                        </div>
                        <div className="nav">
                            <div className="segment-calendar">
                                <div className={"segment-item" + (vm === 0 ? " selected" : "")} onClick={this.changeVM0}>{React.language("month")}</div>
                                <div className={"segment-item" + (vm === 1 ? " selected" : "")} onClick={this.changeVM1}>{React.language("week")}</div>
                            </div>
                        </div>
                    </div>
                    <div className="body-calendar">
                        {vm === 0 && <div className="full-body month-body">
                            <div className="calendarCont">
                                <table>
                                    <thead>
                                        <tr>
                                            {
                                                this.weekArray.map((res) => {
                                                    return <th className="day week">
                                                        {
                                                            res
                                                        }
                                                    </th>
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.trNum.map((res) => {
                                                return <tr>
                                                    {
                                                        this.weekArray.map((res, key) => {
                                                            y = date.getDate()
                                                            let has = false;
                                                            let day = date.getDate()
                                                            let mon = date.getMonth()
                                                            let year = date.getFullYear()
                                                            let dayData = {};
                                                            if (dateData[year]) {
                                                                if (dateData[year][this.numAdd0(mon + 1)]) {
                                                                    if (dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)]) {
                                                                        has = true;
                                                                        dayData = { ...dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)] }
                                                                    }
                                                                }
                                                            }
                                                            let dotColor = '#0265FF  ';
                                                            let textColor = '#333333  ';
                                                            if (newDay === y && newMonth === mon && newYear === year) {
                                                                textColor = '#0265FF'
                                                            }
                                                            if ((selectYear === year && selectDay === y && selectMonth === mon)) {
                                                                textColor = '#fff'
                                                            }
                                                            if (has) {
                                                                var ColorData = "";
                                                                BsyUtils.forEach(bgColorFilter, (bgNum, bgData) => {
                                                                    BsyUtils.forEach(dayData, (obj1, val1) => {

                                                                        BsyUtils.forEach(bgData.options, function (bgNum1, bgData1) {
                                                                            if (that._check_data_bkcolor(val1, bgData1, bgData.tag, bgData.type, bgData)) {
                                                                                if (!ColorData) {
                                                                                    ColorData = bgData1.color;

                                                                                    textColor = "rgb(" + bgData1.colorText + ")  ";
                                                                                    dotColor = "rgb(" + ColorData + ")   ";
                                                                                }
                                                                            }

                                                                        })
                                                                    })
                                                                })


                                                                // console.log(dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)])
                                                            }

                                                            date.setDate(y + 1)
                                                            return <td onClick={this.changeDay(day, mon, year)}
                                                                className={"day"
                                                                    + ((newDay === y && newMonth === mon && newYear === year) ? " today" : "")
                                                                    + ((selectYear === year && selectDay === y && selectMonth === mon) ? " selected" : "")
                                                                    + (selectMonth !== mon ? " odd" : "") + (has ? " hasData" : "")}>
                                                                <div className="day-wrapper">
                                                                    <div className="day-item"
                                                                        style={{
                                                                            color: textColor
                                                                        }}
                                                                    >
                                                                        {
                                                                            y
                                                                        }
                                                                        {
                                                                            has ? <span className="dot" style={{
                                                                                background: dotColor
                                                                            }}></span> : ''
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        })
                                                    }
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="blockCont">
                                {
                                    data.length > 0 ? data.map((res, key) => {
                                        return <div className="block-list" onClick={() => {
                                            this._doShowData(key)
                                        }}>
                                            {
                                                headerData.map((res1) => {
                                                    return this.createBlockItems(res, res1)
                                                })
                                            }
                                        </div>
                                    }) : <div className="empty-cont"><div className="empty-text">{React.language("data.empty")}</div></div>
                                }
                            </div>
                        </div>}
                        {vm === 1 && <div className="full-body week-body">
                            <div className="weekCont">
                                <div className="week-days-wrapper">
                                    {
                                        this.weekArrayCustom.map((res) => {
                                            w = newDate.getDate();


                                            y = newDate.getDate()
                                            let has = false;
                                            let day = newDate.getDate()
                                            let mon = newDate.getMonth()
                                            let year = newDate.getFullYear()
                                            let dayData = {};
                                            if (dateData[year]) {
                                                if (dateData[year][this.numAdd0(mon + 1)]) {
                                                    if (dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)]) {
                                                        has = true;
                                                        dayData = { ...dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)] }
                                                    }
                                                }
                                            }
                                            let dotColor = '#fff';
                                            let textColor = '#333333';
                                            // if(newDay === y && newMonth === mon && newYear === year){
                                            //     textColor = '#0265FF'
                                            // }
                                            // if((selectYear === year && selectDay === y && selectMonth === mon)) {
                                            //     textColor = '#fff'
                                            // }
                                            if (has) {
                                                var ColorData = "";
                                                BsyUtils.forEach(bgColorFilter, (bgNum, bgData) => {
                                                    BsyUtils.forEach(dayData, (obj1, val1) => {

                                                        BsyUtils.forEach(bgData.options, function (bgNum1, bgData1) {
                                                            if (that._check_data_bkcolor(val1, bgData1, bgData.tag, bgData.type, bgData)) {
                                                                if (!ColorData) {
                                                                    ColorData = bgData1.color;

                                                                    textColor = "rgb(" + bgData1.colorText + ")  ";
                                                                    dotColor = "rgb(" + ColorData + ")   ";
                                                                }
                                                            }

                                                        })
                                                    })
                                                })


                                                // console.log(dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)])
                                            }

                                            newDate.setDate(w + 1);
                                            return <div className="week-day-header"
                                                style={{
                                                    color: textColor,
                                                    background: dotColor,
                                                }}
                                            >
                                                {
                                                    w + " " + res
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                                <div className="date-days-wrapper">
                                    <div className="wrapper-content">
                                        {
                                            this.weekArrayCustom.map((res, key1) => {
                                                w2 = newDate2.getDate();
                                                let day = newDate2.getDate()
                                                let mon = newDate2.getMonth()
                                                let year = newDate2.getFullYear()
                                                let has = false;
                                                let datas = []
                                                if (dateData[year]) {
                                                    if (dateData[year][this.numAdd0(mon + 1)]) {
                                                        if (dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)]) {
                                                            has = true;
                                                            data = dateData[year][this.numAdd0(mon + 1)][this.numAdd0(day)];
                                                            datas.push(data)
                                                        }
                                                    }
                                                }
                                                newDate2.setDate(w2 + 1);
                                                return <div className="calendar-data-list week-day-list">
                                                    <div className="x-list size-small">
                                                        {
                                                            (data.length > 0 && has) ? data.map((res, key) => {
                                                                return <div className="block-list" onClick={() => {
                                                                    this.data = datas[0];
                                                                    this._doShowData(key)
                                                                }}>
                                                                    {
                                                                        headerData.map((res1) => {
                                                                            return this.createBlockItems(res, res1)
                                                                        })
                                                                    }
                                                                </div>
                                                            }) : ""
                                                        }
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }

    _isCondItemMatch = (t, e) => {
        const FX = window.FX;
        this.widgetFilterMap = {
            text: TextWidgetFilter,
            number: NumberWidgetFilter,
            formula: NumberWidgetFilter,
            datetime: DatetimeWidgetFilter,
            combocheck: ComboCheckWidgetFilter,
            textarea: TextareaWidgetFilter,
            address: AddressWidgetFilter,
            user: UserWidgetFilter,
            usergroup: UserGroupWidgetFilter,
            dept: DeptWidgetFilter,
            deptgroup: DeptGroupWidgetFilter,
            signature: SignatureWidgetFilter,
            file_list: FileListWidgetFilter,
            flowState: NumberWidgetFilter,
            flowstate: NumberWidgetFilter,
            flowDecision: NumberWidgetFilter,
            flowdecision: NumberWidgetFilter,
            chargers: UserGroupWidgetFilter,
            radiogroup: TextWidgetFilter,
            checkboxgroup: ComboCheckWidgetFilter,
            combo: TextWidgetFilter,
            image: FileListWidgetFilter,
            upload: FileListWidgetFilter,
        }
        var i = this.widgetFilterMap[t.type];
        return !!i && new i(t).invoke()(e)
    }

    _check_data_bkcolor = (data, bkColor, bkColorKey, bkColorType, bkFilterColor) => {
        let b = this;
        let i = b.props;
        let res = "";
        const FX = window.FX;

        if (bkColor) {
            //检查数据条件并设置对应的颜色
            let d = data[bkColorKey];

            if (typeof (data[bkColorKey]) === 'string') {
                try {
                    d = JSON.parse(data[bkColorKey]);
                } catch (e) {

                }
            }
            if (BsyUtils.isObjectEmpty(d)) {

                if (this.bkColor && this.bkColor.length && i.bgColorFilter) {
                    BsyUtils.forEach(this.bkColor, function (index, val) {
                        let method = val.method;
                        let t = {
                            field: i.bgColorFilter.tag,
                            id: i.bgColorFilter.id || i.bgColorFilter.form,
                            method: method == 'formula' ? 'eq' : method,
                            name: i.bgColorFilter.name,
                            type: bkColorType,
                            value: val.term,
                        }
                        let dataItem = null;
                        let hasDataColor = b._isCondItemMatch(t, dataItem);
                        if (hasDataColor) {
                            res = [val.color, val.colorText];
                        }
                    })
                }

                return res
            }
            let dataItem;
            let value;
            let method = bkColor.method;
            if (bkColor.fixed === "currentUser") {
                value = window.FX.STATIC.user.dock_userid ? [window.FX.STATIC.user.dock_userid] : [window.FX.STATIC.user._id];
            } else {
                if (bkColorType === "flowState" || bkColorType === "flowstate" || bkColorType === "flowDecision" || bkColorType === "flowdecision") {
                    value = [bkColor.fixed];
                } else if (bkColorType === "image" || bkColorType === "upload" || bkColorType === "signature") {
                    if (bkColor.fixed.indexOf('NotNull') > -1) {
                        method = 'not_empty';
                    } else {
                        method = 'empty';
                    }
                } else if (bkColorType === "number" || bkColorType === "formula") {
                    value = BsyUtils.isArray(bkColor.term[0]) ? bkColor.term[0] : bkColor.term;
                    let newVal = [];
                    BsyUtils.forEach(value, function (obj, val) {
                        newVal.push(isNaN(Number(val)) ? null : Number(val))
                    })
                    value = newVal;
                } else if (bkColorType === "datetime") {
                    value = BsyUtils.isArray(bkColor.term[0]) ? bkColor.term[0] : bkColor.term;
                    if (bkColor.method == "range") {
                        let newVal = [];
                        BsyUtils.forEach(bkColor.term, function (obj, val) {
                            newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(dayjsUtils.timeToTZ(val)).date, "yyyy-MM-dd"))
                        })
                        value = newVal

                    } else {
                        if (bkColor.fixed !== "fixed") {
                            value = [bkColor.fixed]
                        } else {
                            let newVal = [];
                            BsyUtils.forEach(value, function (obj, val) {
                                newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd"))
                            })
                            value = newVal
                        }
                    }

                } else {
                    value = BsyUtils.isArray(bkColor.term[0]) ? bkColor.term[0] : bkColor.term
                }
            }
            let t = {
                field: bkColorKey,
                id: bkFilterColor.id,
                method: method == 'formula' ? 'eq' : method,
                name: bkColorKey,
                type: bkColorType,
                value: value
            }

            if ((bkColor.fixed === "currentUser" || bkColorKey === "creator" || bkColorType === "user") && bkColorType !== "chargers") {
                dataItem = d.id ? d.id : BsyUtils.isArray(d) ? d.id : d;
            } else if (bkColorType === "usergroup") {
                var usergroup = [];
                BsyUtils.forEach(d, function (obj, val) {
                    usergroup.push(val.id ? val.id : !BsyUtils.isArray(val) ? val.id : val)
                });

                dataItem = usergroup
            } else if (bkColorType === "chargers") {
                var usergroup = [];
                BsyUtils.forEach(d, function (obj, val) {
                    usergroup.push(val.userId ? (val.userId.indexOf('@') >= 0 ? val.userId.split('@')[0] : val.userId) : !BsyUtils.isArray(val) ? (val.userId.indexOf('@') >= 0 ? val.userId.split('@')[0] : val.userId) : val)
                });

                dataItem = usergroup
            } else if (bkColorType === "flowdecision" || bkColorType === "flowDecision") {
                dataItem = d === undefined ? null : Number(d.state_id)
            } else if (bkColorType === "number" || bkColorType === "formula") {
                dataItem = isNaN(Number(d)) ? null : Number(d);
            } else if (bkColorType === "datetime") {
                dataItem = d === undefined ? null : d;
                dataItem = BsyUtils.date2Str(dayjsUtils.timeToTZ(dataItem), "yyyy-MM-dd")
            } else {
                dataItem = d === undefined ? null : d
            }
            var hasDataColor = b._isCondItemMatch(t, dataItem);
            if (hasDataColor) {
                res = [bkColor.color, bkColor.colorText];
            }
        }
        return res;
    }
}
